import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import { useMediaQuery, Box, Container, Toolbar } from "@mui/material";

// project-imports
import Drawer from "./Drawer";
import Header from "./Header";
import Footer from "./Footer";
import HorizontalBar from "./Drawer/HorizontalBar";
import Breadcrumbs from "components/@extended/Breadcrumbs";

import { DRAWER_WIDTH } from "config";
import navigation from "menu-items";
import useConfig from "hooks/useConfig";
import { dispatch } from "store";
import { openDrawer } from "store/reducers/menu";

// types
import { MenuOrientation } from "types/config";
import { fetchProductList } from "utils/getProductData";
import { encryptIDValues } from "helpers/commonHelpers";
import { NavItemType } from "types/menu";
import { FormattedMessage } from "react-intl";
import { ShoppingBag } from "iconsax-react";

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const downXL = useMediaQuery(theme.breakpoints.down("xl"));
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const [productMenu, setProductMenu] = useState<NavItemType>({});

  const { container, miniDrawer, menuOrientation } = useConfig();

  const icons = {
    product: ShoppingBag,
  };

  fetchProductList()
    .then((productList: any) => {
      const productMenuItems = productList.map((product: any) => ({
        id: product.value,
        title: product.label,
        type: "item",
        url: `/products-detail/${encryptIDValues(product.value)}`,
        icon: icons.product,
      }));
      const product: NavItemType = {
        id: "group-product",
        title: <FormattedMessage id="Products" />,
        icon: icons.product,
        type: "group",
        children: productMenuItems,
        breadcrumbs: false,
      };
      setProductMenu(product);
    })
    .catch((error) => {
      console.error(error);
    });

  const updatedMenuItem = {
    ...navigation,
    items: [...navigation.items, productMenu],
  };

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      dispatch(openDrawer(!downXL));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  return (
    <Box sx={{ display: "flex", width: "100%" }}>
      <Header />
      {!isHorizontal ? <Drawer /> : <HorizontalBar />}

      <Box
        component="main"
        sx={{
          width: `calc(100% - ${DRAWER_WIDTH}px)`,
          flexGrow: 1,
          p: { xs: 2, md: 3 },
        }}
      >
        <Toolbar
          sx={{
            mt: isHorizontal ? 8 : "inherit",
            mb: isHorizontal ? 2 : "inherit",
          }}
        />
        <Container
          maxWidth={container ? "xl" : false}
          sx={{
            xs: 0,
            ...(container && { px: { xs: 0, md: 2 } }),
            position: "relative",
            minHeight: "calc(100vh - 110px)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Breadcrumbs
            navigation={updatedMenuItem}
            title
            titleBottom
            card={false}
            divider={false}
          />
          <Outlet />
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;
